<template>
  <div id="carbonEmission" style="height: calc(100% - 80px)">
    <!-- 碳排放量 -->
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: "carbonEmission",
  props: {
    chartData1: { type: Object, default: null },
    chartData2: { type: Object },
    monthData: { type: Array },
    flag: { type: Boolean }
  },
  data () {
    return {
      emphasisStyle: {
        itemStyle: {
          shadowBlur: 10,
          shadowColor: 'rgba(0,0,0,0.3)'
        }
      },
      carbonmyChart: {}
    }
  },
  watch: {
    monthData: {
      handler (newName, oldName) {
        if (newName != null) {
          let that = this
          setTimeout(function () {
            that.chartInvid()
          }, 1000)
        }
      },
      immediate: true
    }
  },
  methods: {
    chartInvid () {
      this.carbonmyChart = echarts.init(document.getElementById("carbonEmission"));
      this.carbonmyChart.setOption(this.carbonoption);
    }
  },
  mounted () {
  },

  computed: {
    carbonoption () {
      return {
        title: {
          //text: '单位:万tCO₂',
          text: '单位:吨',//用能趋势
          top: 20,
          textStyle: {
            color: '#fff',
            fontSize: 12,
          }
        },
        legend: {
          //data: ['化石燃料', '碳酸盐分解', '非燃料碳煅烧', '购入电力'],
          right: '0%',
          top: '0%',
          textStyle: {
            color: "#fff",
            fontSize: 12
          }
        },
        tooltip: {
          axisPointer: {
            label: {
              //show: true
            }
          }
        },
        xAxis: {
          data: this.monthData,
          splitArea: { show: false },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#45a2ff',
            },
          },
          splitLine: { show: false },//去除网格线
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 16,
            color: '#fff',
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#45a2ff',
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#182266',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 14,
            color: '#fff',
          },
        },
        grid: {
          bottom: 30
        },
        series: [
          {
            //name: '化石燃料',
            type: 'bar',
            stack: 'one',
            emphasis: this.emphasisStyle,
            data: [500,600,650,0],
            itemStyle: {
              color: '#096ee3'  //#01d6e2
            }
          },
          {
            //name: '碳酸盐分解',
            type: 'bar',
            stack: 'one',
            emphasis: this.emphasisStyle,
            data: [],
            itemStyle: {
              color: '#55e7af'  //#f0bd42
            }
          },
          {
            //name: '非燃料碳煅烧',
            type: 'bar',
            stack: 'one',
            emphasis: this.emphasisStyle,
            data: this.chartData1.非燃料碳煅烧,
            itemStyle: {
              color: '#f0bd42'  //#55e7af
            }
          },
          {
            //name: '购入电力',
            type: 'bar',
            stack: 'one',
            emphasis: this.emphasisStyle,
            data: this.chartData1.购入电力,
            // barWidth: 20,
            barGap: "65%",
            itemStyle: {
              normal: {
                label: {
                  //formatter: "1号线",
                  //show: true,
                  position: "top",
                  textStyle: {
                    fontSize: "12",
                    color: "#fff"
                  }
                },
                opacity: 1,

              },
              color: '#55e7af'  //#096ee3
            }
          },

        ]
      }
    }

  },
}
</script>

<style scoped>
.opp {
  color: #45a2ff;
}
</style>



// WEBPACK FOOTER //
// src/components/left/carbonEmission.vue